import { Customer } from "@api/types";
import { BanIcon, ChatAlt2Icon, DotsHorizontalIcon } from "@heroicons/react/outline";
import { formatDate, getCustomerAvatarSrc, getCustomerName, getCustomerSource } from "@lib/utils";
import { CustomerMessageLink } from "@ui/components/customer-message-link";
import DropdownButton, { MenuOption } from "@ui/components/dropdown-button";
import PageHeading from "@ui/components/page-heading";
import { Avatar } from "@ui/elements";

interface ContactPageHeadingProps {
  customer: Customer;
  dropdownOptions?: Array<MenuOption | MenuOption[]>;
}
export function ContactPageHeading(props: ContactPageHeadingProps) {
  const customerSource = getCustomerSource(props.customer);
  const avatarSrc = getCustomerAvatarSrc(props.customer);

  return (
    <PageHeading
      title={
        <div className="flex items-center space-x-5">
          <Avatar name={getCustomerName(props.customer)} src={avatarSrc} size="xl" />
          <div>
            <h1 className="text-2xl font-bold text-foreground flex items-center">
              <span>{getCustomerName(props.customer)}</span>
              {props.customer.optout ? <BanIcon className="text-gray-400 w-5 h-5 ml-1" /> : null}
            </h1>
            <p className="text-sm font-medium text-gray-500">
              Added
              {customerSource === "helios" ? (
                ` ${formatDate(props.customer.createdAt, "DD")}`
              ) : (
                <>
                  {" "}
                  with{" "}
                  <span className="capitalize text-gray-600">
                    {customerSource} integration
                  </span>{" "}
                </>
              )}
            </p>
          </div>
        </div>
      }
      actions={
        <div className="flex items-center ml-3 space-x-2">
          <CustomerMessageLink className="btn btn--default" customer={props.customer}>
            <ChatAlt2Icon className="inline-block w-5 h-5 mr-2" />
            Message
          </CustomerMessageLink>
          {props.dropdownOptions ? (
            <DropdownButton
              options={props.dropdownOptions}
              button={
                <a className="btn btn--default btn--sm">
                  <DotsHorizontalIcon className="w-5 h-5 text-gray-500" />
                </a>
              }
            />
          ) : null}
        </div>
      }
    />
  );
}
